<template>
  <div class="fuel">
    <v-card class="list-food">
      <v-toolbar flat>
        <v-toolbar-title>Food Database</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="foods"
        :loading="loading"
      >
        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
        <template slot="items" slot-scope="props">
          <td>
            {{ props.item.name }}<br>
            <div class="small-grey">id: {{ props.item.id }}</div>
          </td>
          <td class="text-xs-right">{{ props.item.calories }}</td>
          <td class="text-xs-right">{{ props.item.fat }}</td>
          <td class="text-xs-right">{{ props.item.carbs }}</td>
          <td class="text-xs-right">{{ props.item.protein }}</td>
          <td class="text-xs-right">{{ props.item.iron }}</td>
        </template>
      </v-data-table>
    </v-card>
    <v-container grid-list-md text-xs-center class="food-tab">
      <v-card class="add-food mt-4">
        <v-toolbar flat>
          <v-toolbar-title>Add Food</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-form v-model="valid" class="food-form" lazy-validation>
          <v-flex xs6 sm12 md12>
            <v-text-field v-model="name" label="Product Name" required></v-text-field>
          </v-flex>
          <v-subheader>Basic</v-subheader>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-text-field 
                v-model="product"
                label="Product Number"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field 
                v-model="brand"
                label="Brand Name"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-text-field 
                v-model="price"
                label="Price"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field 
                v-model="url"
                label="Item URL"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-text-field 
                v-model="serving"
                label="Serving"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field 
                v-model="net"
                label="Net Size"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <!-- <v-flex xs12 md6>
              <v-text-field 
                v-model="serving"
                label="Serving"
                required
              ></v-text-field>
            </v-flex> -->
            <v-flex xs12 md6>
              <v-select
                :items="units"
                label="Units"
                required
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-text-field 
                v-model="calories"
                label="Calories"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field 
                v-model="caloriesFromFat"
                label="Calories from Fat"
                required
              ></v-text-field>
            </v-flex>  
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-text-field 
                v-model="cholesterol"
                label="Cholesterol"
                suffix="mg"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field 
                v-model="sodium"
                label="Sodium"
                suffix="mg"
                required
              ></v-text-field>
            </v-flex>  
          </v-layout>
          <v-subheader>Fat</v-subheader>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-text-field 
                v-model="polyunsaturated"
                label="Polyunsaturated Fat"
                suffix="g"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field 
                v-model="saturated"
                label="Saturated Fat"
                suffix="g"
                required
              ></v-text-field>
            </v-flex>  
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 md6>  
              <v-text-field 
                v-model="monounsaturated"
                label="Monounsatured Fat"
                suffix="g"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field 
                v-model="trans"
                label="Trans Fat"
                suffix="g"
                required
              ></v-text-field>
            </v-flex>  
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-text-field 
                v-model="omega3"
                label="Omega-3"
                suffix="mg"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field 
                v-model="omega6"
                label="Omega-6"
                suffix="mg"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-text-field 
                v-model="dha"
                label="DHA"
                suffix="mg"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field 
                v-model="epa"
                label="EPA"
                suffix="mg"
                required
              ></v-text-field>
            </v-flex>  
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 md6>  
              <v-text-field 
                v-model="totalFat"
                label="Total Fat"
                suffix="g"
                required
              ></v-text-field>
            </v-flex>  
          </v-layout>
          <v-subheader>Carbohydrates</v-subheader>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-text-field 
                v-model="total"
                label="Total"
                suffix="g"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field 
                v-model="fiber"
                label="Dietary Fiber"
                suffix="g"
                required
              ></v-text-field>
            </v-flex>  
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-text-field 
                v-model="sugar"
                label="Sugars"
                suffix="g"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field 
                v-model="other"
                label="Other"
                suffix="g"
                required
              ></v-text-field>
            </v-flex>  
          </v-layout>
          <v-subheader>Protein</v-subheader>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-text-field 
                v-model="protein"
                label="Protein"
                suffix="g"
                required
              ></v-text-field>
            </v-flex> 
          </v-layout>
          <v-subheader>Micronutrients</v-subheader>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-text-field 
                v-model="calcium"
                label="Calcium"
                :mask="mask_percent"
                suffix="%"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field 
                v-model="copper"
                label="Copper"
                :mask="mask_percent"
                suffix="%"
                required
              ></v-text-field>
            </v-flex> 
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-text-field 
                v-model="iron"
                label="Iron"
                :mask="mask_percent"
                suffix="%"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field 
                v-model="magnesium"
                label="Magnesium"
                :mask="mask_percent"
                suffix="%"
                required
              ></v-text-field>
            </v-flex> 
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-text-field 
                v-model="potassium"
                label="Potassium"
                :mask="mask_percent"
                suffix="%"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field 
                v-model="riboflavin"
                label="Riboflavin"
                :mask="mask_percent"
                suffix="%"
                required
              ></v-text-field>
            </v-flex> 
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-text-field 
                v-model="selenium"
                label="Selenium"
                :mask="mask_percent"
                suffix="%"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field 
                v-model="thiamine"
                label="Thiamine"
                :mask="mask_percent"
                suffix="%"
                required
              ></v-text-field>
            </v-flex> 
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-text-field 
                v-model="zinc"
                label="Zinc"
                :mask="mask_percent"
                suffix="%"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field 
                v-model="vitaminA"
                label="Vitamin A"
                :mask="mask_percent"
                suffix="%"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-text-field 
                v-model="vitaminB12"
                label="Vitamin B12"
                :mask="mask_percent"
                suffix="%"
                required
              ></v-text-field>
            </v-flex> 
            <v-flex xs12 md6>
              <v-text-field 
                v-model="vitaminB6"
                label="Vitamin B6"
                :mask="mask_percent"
                suffix="%"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-text-field 
                v-model="vitaminC"
                label="Vitamin C"
                :mask="mask_percent"
                suffix="%"
                required
              ></v-text-field>
            </v-flex> 
            <v-flex xs12 md6>
              <v-text-field 
                v-model="vitaminK"
                label="Vitamin K"
                :mask="mask_percent"
                suffix="%"
                required
              ></v-text-field>
            </v-flex> 
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-text-field 
                v-model="manganese"
                label="Manganese"
                :mask="mask_percent"
                suffix="%"
                required
              ></v-text-field>
            </v-flex> 
            <v-flex xs12 md6>
              <v-text-field 
                v-model="folate"
                label="Folate"
                :mask="mask_percent"
                suffix="%"
                required
              ></v-text-field>
            </v-flex> 
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-text-field 
                v-model="vitaminE"
                label="Vitamin E"
                :mask="mask_percent"
                suffix="%"
                required
              ></v-text-field>
            </v-flex> 
            <v-flex xs12 md6>
              <v-text-field 
                v-model="vitaminD"
                label="Vitamin D"
                :mask="mask_percent"
                suffix="%"
                required
              ></v-text-field>
            </v-flex> 
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-text-field 
                v-model="chromium"
                label="Chromium"
                :mask="mask_percent"
                suffix="%"
                required
              ></v-text-field>
            </v-flex> 
            <v-flex xs12 md6>
              <v-text-field 
                v-model="biotin"
                label="Biotin"
                :mask="mask_percent"
                suffix="%"
                required
              ></v-text-field>
            </v-flex> 
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-text-field 
                v-model="niacin"
                label="Niacin"
                :mask="mask_percent"
                suffix="%"
                required
              ></v-text-field>
            </v-flex> 
            <v-flex xs12 md6>
              <!-- <v-text-field 
                v-model="vitaminD"
                label="Vitamin D"
                :mask="mask_percent"
                suffix="%"
                required
              ></v-text-field> -->
            </v-flex> 
          </v-layout>
          <v-btn
            :disabled="!valid"
            @click="submit"
          >
            submit
          </v-btn>
        </v-form>
      </v-card>
    </v-container>
    <v-snackbar v-model="snackbar">
      Food Added Successfully.
    </v-snackbar>
  </div>
</template>

<script>
import db from '@/firebase/firestore'
export default {
  name: 'Food',
  data() {
    return {
      snackbar: false,
      valid: true,
      mask_percent: '###',
      mask_number: '###',
      loading: true,
      selected: [],
      headers: [
        {
          text: 'Item Name',
          align: 'left',
          sortable: true,
          value: 'name'
        },
        { text: 'Calories', value: 'calories' },
        { text: 'Fat (g)', value: 'fat' },
        { text: 'Carbs (g)', value: 'carbs' },
        { text: 'Protein (g)', value: 'protein' },
        { text: 'Iron (%)', value: 'iron' }
      ],
      foods: [],
      units: [
        'g',
        'mL'
      ],
      // Food Form
      brand: 'Presidents Choice',
      calcium: 0,
      calories: 0,
      caloriesFromFat: 0,
      fiber: 0,
      other: 0,
      sugars: 0,
      total: 0,
      totalFat: 0,
      cholesterol: 0,
      copper: 0,
      dha: 0,
      epa: 0,
      monounsaturated: 0,
      omega3: 0,
      omega6: 0,
      polyunsaturated: 0,
      saturated: 0,
      trans: 0,
      iron: 0,
      magnesium: 0,
      name: "",
      potassium: 0,
      price: 0,
      product: "",
      protein: 0,
      riboflavin: 0,
      selenium: 0,
      serving: 0,
      net: 0,
      sodium: 0,
      sugar: 0,
      thiamine: 0,
      unit: "g",
      url: "",
      vitaminA: 0,
      vitaminB12: 0,
      vitaminB6: 0,
      vitaminC: 0,
      vitaminD: 0,
      vitaminE: 0,
      vitaminK: 0,
      zinc: 0,
      manganese: 0,
      folate: 0,
      chromium: 0,
      biotin: 0,
      niacin: 0
    }
  },
  methods: {
    submit() {
      this.valid = false
      let ref = db.collection('food').add({
        brand: this.brand,
        calcium: this.calcium,
        calories: this.calories,
        caloriesFromFat: this.caloriesFromFat,
        carbohydrates: {
          fiber: this.fiber,
          other: this.other,
          sugars: this.sugars,
          total: this.total,
        },
        cholesterol: this.cholesterol,
        copper: this.copper,
        fat: {
          dha: this.dha,
          epa: this.epa,
          monounsaturated: this.monounsaturated,
          omega3: this.omega3,
          omega6: this.omega6,
          polyunsaturated: this.polyunsaturated,
          saturated: this.saturated,
          trans: this.trans,
          total: this.totalFat
        },
        iron: this.iron,
        magnesium: this.magnesium,
        name: this.name,
        potassium: this.potassium,
        price: this.price,
        product: this.product,
        protein: this.protein,
        riboflavin: this.riboflavin,
        selenium: this.selenium,
        serving: this.serving,
        net: this.net,
        sodium: this.sodium,
        thiamine: this.thiamine,
        unit: this.unit,
        url: this.url,
        vitaminA: this.vitaminA,
        vitaminB12: this.vitaminB12,
        vitaminB6: this.vitaminB6,
        vitaminC: this.vitaminC,
        vitaminD: this.vitaminD,
        vitaminE: this.vitaminE,
        vitaminK: this.vitaminK,
        zinc: this.zinc,
        manganese: this.manganese,
        folate: this.folate,
        chromium: this.chromium,
        biotin: this.biotin,
        niacin: this.niacin
      }).then((result) => {
        console.log(result)
        this.snackbar = true
        this.valid = true
      })
    }
  },
  created () {
    let ref = db.collection('food')
    ref.get().then((snapshot) => {
      this.loading = false
      snapshot.forEach( doc => {
        let food = doc.data()
        this.foods.push({
          id: food.id,
          value: false,
          name: food.name,
          calories: food.calories,
          // fat: food.fat.total,
          carbs: food.carbohydrates.total,
          protein: food.protein,
          iron: food.iron
        })
      })
    })
  }
}
</script>

<style scoped>
  .add {
    margin-top: 10px;
  }
  .food-form {
    padding: 20px;
    margin: 0 16px;
  }
  .v-subheader {
    padding: 0;
  }
  .small-grey {
    font-size: 8px;
    color: #757575;
  }
</style>
